import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useMemo } from 'react'
import { ResetPassword } from '@/features/auth/reset-password'

const searchSchema = z.object({
  code: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/(auth)/reset-password')({
  validateSearch: searchSchema,
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  const { code: codeFromSearch } = Route.useSearch()
  const code = useMemo(() => {
    if (codeFromSearch) return codeFromSearch
    if (typeof window === 'undefined') return undefined
    return new URLSearchParams(window.location.search).get('code') || undefined
  }, [codeFromSearch])
  return <ResetPassword code={code} />
}
